module.exports = __webpack_public_path__ + "media/src/website/images/locations/rimsting/rimsting_small_03-e4b79118598f4f38569433da91b10bd0.jpg";